var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[(_vm.loggedIn)?_c('v-container',[_c('AdminBar'),_c('PlaylistTable')],1):_c('PasswordChecker',{on:{"loggedIn":_vm.login}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }